<template>
  <div id="lock-screen" v-if="show"></div>
</template>

<script>
import { getStuBookScreen } from "./indexApi";
export default {
  name: "lock-screen",
  data() {
    return {
      //是否显示锁屏
      show: false,
    };
  },
  props: ["data"],
  watch: {
    data(val) {
      console.log(val);
      this.jude_show(val);
    },
  },
  computed: {},
  methods: {
    //判断是否显示锁屏
    jude_show(data) {
      if (!data) {
        return;
      }
      console.log(data);
      if (
        data.class_id == this.$cookies.get("class_id") &&
        this.$cookies.get("user_type") == this.identity.student &&
        data.lock_screen_status
      ) {
        if (this.show) {
          if (this.getDeviceInfo()) {
            // IMAppObj.lockDrawBoard();
          }
          return;
        } else {
          this.getMaiSuiSwitch();
          if (this.getDeviceInfo()) {
            // IMAppObj.unlockDrawBoard();
          }
        }
      } else {
        this.show = false;
      }
    },
    //获取麦穗接口
    getMaiSuiSwitch() {
      getStuBookScreen()
        .then((res) => {
          if (res.errCode == 0) {
            // this.getDeviceInfo('2') 传参代表为过滤非麦穗平板
            console.log("判断是否为非麦穗");
            console.log(this.getMaisuiInfo());
            if (!res.data.status || !this.getMaisuiInfo()) {
              this.show = true;
            } else {
              this.show = false;
            }
          } else {
            this.$message(res.msg);
          }
        })
        .catch((err) => {
          throw new Error(err);
        });
    },
  },
  created() {},
  components: {},
  mounted() {
    this.jude_show(this.data);
  },
};
</script>

<style lang="scss" scoped>
#lock-screen {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999999999999999;
  background: url("../../assets/images/student_lock_screen.png") no-repeat
    center center;
  background-size: 100% 100%;
}
</style>
